import { React, PropTypes } from 'imports';
import { FormattedResource } from '..';
import DropPanel from '../DropPanel/DropPanel';
import RadioGroup from '../RadioGroup/RadioGroup';
import TimeStamp from '../TimeStamp/TimeStamp';
import { DayAlignment as DateAlignment } from '../DateInput/DateInput';
import DayPicker from 'react-day-picker';
import withDateLocaleUtils, { dateLocaleUtilsPropTypes } from '../withDateLocaleUtils/withDateLocaleUtils';
import { PeriodType } from 'utils/constants';
import DateRange from 'utils/DateRange';
import 'react-day-picker/lib/style.css';
import './PeriodCalendar.less';

const TIME_PERIOD_TRANSLATION_MAP = {
    [PeriodType.DAY]: 'common.period.day',
    [PeriodType.WEEK]: 'common.period.week',
    [PeriodType.MONTH]: 'common.period.month',
    [PeriodType.QUARTER]: 'common.period.quarter',
    [PeriodType.YEAR]: 'common.period.year'
};

export { PeriodType, DateAlignment };

export const periodTypePropType = PropTypes.oneOfType([
    PropTypes.oneOf(Object.values(PeriodType)),
    PropTypes.shape({
        ID: PropTypes.number.isRequired,
        Description: FormattedResource.resourcePropType.isRequired
    })
]);

class PeriodCalendar extends React.PureComponent {
    static get PeriodType() {
        return PeriodType;
    }

    static DateAlignment() {
        return DateAlignment;
    }

    static get periodTypePropType() {
        return periodTypePropType;
    }

    static get propTypes() {
        return {
            value: PropTypes.instanceOf(DateRange), // TODO create class similar to DateRange, but containing only PeriodType + single Date
            periodTypes: PropTypes.arrayOf(periodTypePropType),
            alignment: PropTypes.oneOf(Object.values(DateAlignment)),
            minDate: PropTypes.instanceOf(Date),
            maxDate: PropTypes.instanceOf(Date),
            disabled: PropTypes.bool,
            onChange: PropTypes.func,

            ...dateLocaleUtilsPropTypes
        };
    }

    static get defaultProps() {
        return {
            periodTypes: Object.values(PeriodType),
            alignment: DateAlignment.START
        };
    }

    componentDidUpdate() {
        // dirty hacks,
        // DayPicker doesn't have any week modifiers, so to show week selection we have to update classes manually
        // and Popup renders content asynchronously, so we have to wait for it to be done before classes update
        setTimeout(() => {
            let popup;
            if (this.state && this.state.visiblePeriodType === PeriodType.WEEK && this.refs['drop-panel'] && (popup = this.refs['drop-panel'].refs['popup'])) {

                Array.from(popup.container.querySelectorAll('.DayPicker-Week--today'))
                    .filter(week => !week.querySelector('.DayPicker-Day--today'))
                    .forEach(untodayWeek => untodayWeek.className = untodayWeek.className.replace(/\s+DayPicker-Week--today/, ''));

                Array.from(popup.container.querySelectorAll('.DayPicker-Week--selected'))
                    .filter(week => !week.querySelector('.DayPicker-Day--selected'))
                    .forEach(unselectedWeek => unselectedWeek.className = unselectedWeek.className.replace(/\s+DayPicker-Week--selected/, ''));

                Array.from(popup.container.querySelectorAll('.DayPicker-Week--disabled'))
                    .filter(week => !week.querySelector('.DayPicker-Day--disabled'))
                    .forEach(undisabledWeek => undisabledWeek.className = undisabledWeek.className.replace(/\s+DayPicker-Week--disabled/, ''));

                Array.from(popup.container.querySelectorAll('.DayPicker-Week'))
                    .filter(week => !week.className.includes('--today') && week.querySelector('.DayPicker-Day--today'))
                    .forEach(retodayWeek => retodayWeek.className += ' DayPicker-Week--today');

                Array.from(popup.container.querySelectorAll('.DayPicker-Week'))
                    .filter(week => !week.className.includes('--selected') && week.querySelector('.DayPicker-Day--selected'))
                    .forEach(reselectedWeek => reselectedWeek.className += ' DayPicker-Week--selected');

                Array.from(popup.container.querySelectorAll('.DayPicker-Week'))
                    .filter(week => !week.className.includes('--disabled') && week.querySelector('.DayPicker-Day--disabled'))
                    .forEach(redisabledWeek => redisabledWeek.className += ' DayPicker-Week--disabled');
            }
        }, 0);
    }

    state = {
        visiblePeriodType: null,
        visibleDate: null
    }

    componentWillMount() {
        const { value, periodTypes: [mostDetailedPeriodType] } = this.props;
        this.setState({
            visiblePeriodType: value ? value.periodType : mostDetailedPeriodType.ID || mostDetailedPeriodType,
            visibleDate: value ? value.last : new Date()
        });
    }

    _onVisiblePeriodTypeChange = (sender, value) => {
        this.setState({ visiblePeriodType: value });
    }

    _onVisibleDateChange = (value) => {
        this.setState({ visibleDate: value });
    }

    _onTickClick = (date) => {
        const result = new DateRange(this.state.visiblePeriodType, date);
        if (this.props.alignment === DateAlignment.END) {
            // TODO make Alignment a part of DateRange
            result.move(1);
            result.last = new Date(result.last - 1);
            result.first = new Date(result.first - 1);
        }

        if (this.props.onChange &&
            (!this.props.minDate || result.last >= this.props.minDate) &&
            (!this.props.maxDate || result.last <= this.props.maxDate)
        ) {
            this.props.onChange(this, result);
        }
    }

    _onWeekClick = (weekNumber, days) => {
        this._onTickClick(days[0]);
    }

    render() {
        const
            { value, periodTypes, minDate, maxDate, disabled } = this.props,
            { visiblePeriodType, visibleDate } = this.state;

        let prevVisibleDate, visibleRange = null, visibleRangeDescription, nextVisibleDate;
        switch (visiblePeriodType) {
            case null: break;

            //TODO move this stuff to DateRange/PeriodType+Date thing
            case PeriodType.YEAR:
                prevVisibleDate = new Date(new Date(visibleDate).setUTCFullYear(visibleDate.getUTCFullYear() - 12));
                visibleRange = new DateRange(visiblePeriodType, visibleDate);
                visibleRange.first = new DateRange(visiblePeriodType, visibleDate).move(1 - 6).last;
                visibleRange.last = new DateRange(visiblePeriodType, visibleRange.first).move(12).previous;
                visibleRangeDescription = (
                    <span>
                        <TimeStamp detalizationPeriodType={PeriodType.YEAR} exactDatePeriodType={null} value={visibleRange.first} />
                        &nbsp;&ndash;&nbsp;
                        <TimeStamp detalizationPeriodType={PeriodType.YEAR} exactDatePeriodType={null} value={visibleRange.last} />
                    </span>
                );
                nextVisibleDate = new Date(new Date(visibleDate).setUTCFullYear(visibleDate.getUTCFullYear() + 12));
                break;

            case PeriodType.QUARTER:
                prevVisibleDate = new Date(new Date(visibleDate).setUTCQuarter(visibleDate.getUTCQuarter() - 12));
                visibleRange = new DateRange(visiblePeriodType, visibleDate);
                visibleRange.first = new DateRange(visiblePeriodType, visibleDate).move(-visibleDate.getUTCQuarter() + 1 - 4).last;
                visibleRange.last = new DateRange(visiblePeriodType, visibleRange.first).move(12).previous;
                visibleRangeDescription = (
                    <span>
                        <TimeStamp detalizationPeriodType={PeriodType.YEAR} exactDatePeriodType={null} value={visibleRange.first} />
                        &nbsp;&ndash;&nbsp;
                        <TimeStamp detalizationPeriodType={PeriodType.YEAR} exactDatePeriodType={null} value={visibleRange.last} />
                    </span>
                );
                nextVisibleDate = new Date(new Date(visibleDate).setUTCQuarter(visibleDate.getUTCQuarter() + 12));
                break;

            case PeriodType.MONTH:
                prevVisibleDate = new Date(new Date(visibleDate).setUTCFullYear(visibleDate.getUTCFullYear() - 1));
                visibleRange = new DateRange(visiblePeriodType, visibleDate);
                visibleRange.first = new DateRange(visiblePeriodType, visibleDate).move(-visibleDate.getUTCMonth()).last;
                visibleRange.last = new DateRange(visiblePeriodType, visibleRange.first).move(12).previous;
                visibleRangeDescription = <TimeStamp detalizationPeriodType={PeriodType.YEAR} exactDatePeriodType={null} value={visibleDate} />;
                nextVisibleDate = new Date(new Date(visibleDate).setUTCFullYear(visibleDate.getUTCFullYear() + 1));
                break;

            case PeriodType.WEEK:
            case PeriodType.DAY:
                prevVisibleDate = new Date(new Date(visibleDate).setUTCMonth(visibleDate.getUTCMonth() - 1));
                visibleRangeDescription = <TimeStamp detalizationPeriodType={PeriodType.MONTH} exactDatePeriodType={null} value={visibleDate} />;
                nextVisibleDate = new Date(new Date(visibleDate).setUTCMonth(visibleDate.getUTCMonth() + 1));
                break;
        }

        return (
            <div className="period-calendar">
                {
                    visiblePeriodType && periodTypes.length > 1 ?
                        <RadioGroup
                            className="control-group"
                            layout={RadioGroup.Layout.HORIZONTAL}
                            appearance={RadioGroup.Appearance.BUTTON}
                            disabled={disabled}
                            onChange={this._onVisiblePeriodTypeChange}
                            value={visiblePeriodType}>
                            {periodTypes.map(pt =>
                                typeof pt === 'number' ?
                                    <RadioGroup.Option key={pt} value={pt}>
                                        <FormattedResource resource={{ id: TIME_PERIOD_TRANSLATION_MAP[pt] }} />
                                    </RadioGroup.Option> :
                                    <RadioGroup.Option key={pt.ID} value={pt.ID}>
                                        <FormattedResource resource={pt.Description} />
                                    </RadioGroup.Option>
                            )}
                        </RadioGroup> :
                        null
                }
                {
                    visiblePeriodType ?
                        <div className="range">
                            <button className="inline fa fa-chevron-left" disabled={disabled} onClick={this._onVisibleDateChange.bind(this, prevVisibleDate)} />
                            <button className="inline fa fa-chevron-right" disabled={disabled} onClick={this._onVisibleDateChange.bind(this, nextVisibleDate)} />
                            <div>{visibleRangeDescription}</div>
                        </div> :
                        null
                }
                {
                    visiblePeriodType ?
                        visiblePeriodType !== PeriodType.DAY && visiblePeriodType !== PeriodType.WEEK ?
                            <div className="ticks">
                                {
                                    visibleRange
                                        .ticks()
                                        .group((_, index) => (index / 4) | 0)
                                        .map(group =>
                                            <div key={group.key} className="group">
                                                {
                                                    visiblePeriodType === PeriodType.QUARTER ?
                                                        <div className="name">{new Date(group[0]).getFullYear()}</div> :
                                                        null
                                                }
                                                {group.map(tick =>
                                                    <div key={tick}
                                                        className={
                                                            'tick ' +
                                                            (value && value.periodType === visiblePeriodType && +tick === +value.last ? ' active' : '') +
                                                            (+tick === +new DateRange(visiblePeriodType, new Date()).last ? ' current' : '') +
                                                            (minDate && tick < new DateRange(visiblePeriodType, minDate).last || maxDate && tick >= new DateRange(visiblePeriodType, maxDate).next ? ' disabled' : '')
                                                        }
                                                        disabled={disabled}
                                                        onClick={this._onTickClick.bind(this, tick)}>
                                                        <TimeStamp detalizationPeriodType={visiblePeriodType} exactDatePeriodType={null} short value={new Date(tick)} />
                                                    </div>
                                                )}
                                            </div>
                                        )
                                }
                            </div> :
                            <DayPicker
                                className={visiblePeriodType === PeriodType.DAY ? 'day' : 'week'}
                                locale={this.props.locale}
                                localeUtils={this.props.localeUtils}
                                canChangeMonth={false}
                                showWeekNumbers
                                firstDayOfWeek={1}
                                month={visibleDate}
                                disabled={disabled}
                                disabledDays={d => minDate && d < new DateRange(visiblePeriodType, minDate).last || maxDate && d >= new DateRange(visiblePeriodType, maxDate).next}
                                selectedDays={d => value && value.periodType === visiblePeriodType && d >= value.last && d < value.next}
                                onWeekClick={visiblePeriodType === PeriodType.WEEK ? this._onWeekClick : () => { /*DayPicker doesn't check for handler nullity and fails if handler is not passed */ }}
                                onDayClick={this._onTickClick} /> :
                        null
                }
            </div>
        );
    }
}

export default withDateLocaleUtils(PeriodCalendar);